/* global __PRIME_BUILD_INFO__ */

const DEFAULT_BUILD_INFO = Object.freeze({
  version: 'dev',
  builtAt: null,
  mode: 'development',
});

function normalizeMode(value) {
  const mode = String(value || '').trim();
  return mode || DEFAULT_BUILD_INFO.mode;
}

function normalizeVersion(value) {
  const version = String(value || '').trim();
  return version || DEFAULT_BUILD_INFO.version;
}

function normalizeBuiltAt(value) {
  if (!value) return null;
  const parsed = new Date(value);
  if (Number.isNaN(parsed.valueOf())) return null;
  return parsed.toISOString();
}

export function normalizeBuildInfo(raw = null) {
  return {
    version: normalizeVersion(raw?.version),
    builtAt: normalizeBuiltAt(raw?.builtAt),
    mode: normalizeMode(raw?.mode),
  };
}

export function getBuildInfo() {
  const injected =
    typeof __PRIME_BUILD_INFO__ !== 'undefined'
      ? __PRIME_BUILD_INFO__
      : globalThis.__PRIME_BUILD_INFO__ || null;
  return normalizeBuildInfo(injected);
}

export function formatBuildVersion(version) {
  const normalized = normalizeVersion(version);
  const match = normalized.match(/^pmhub-release-\d{8}-\d{6}-([0-9a-f]{7})$/i);
  if (match) {
    return match[1];
  }
  return normalized;
}

export function formatBuildDateTime(
  builtAt,
  { locale = undefined, timeZone = undefined } = {},
) {
  const normalized = normalizeBuiltAt(builtAt);
  if (!normalized) return '';

  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
    timeZone,
  }).format(new Date(normalized));
}
